module.exports = __webpack_public_path__ + "img/two_factor_authentication.d79b3566.png";